module.exports = __webpack_public_path__ + "media/images/pic/certificates/produkt-najwyzszej-jakosci-2d9761b9a99a626ad3558f615d997c76.png";